import React from 'react';
import styles from './Tabs.module.scss';

export default function Tabs({ children }) {
  return <div className={styles.tabs}>{children}</div>;
}
